import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 18.332 18.332"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7986",
  class: "cls-1",
  d: "m14.352 6.855-6.48 6.479L3.987 9.45l1.292-1.292 2.593 2.592 5.187-5.187ZM1.833 9.119a7.283 7.283 0 0 1 2.4-5.389l2.182 2.181v-5.5h-5.5l2.018 2.018a9.143 9.143 0 0 0 5.315 15.809v-1.852a7.336 7.336 0 0 1-6.415-7.267Zm16.5 0A9.163 9.163 0 0 0 10.081 0v1.85A7.3 7.3 0 0 1 14.1 14.507l-2.181-2.181v5.5h5.5L15.4 15.809a9.1 9.1 0 0 0 2.929-6.69Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };